import { render, staticRenderFns } from "./sevenPic.vue?vue&type=template&id=35e6ec6f&scoped=true"
import script from "./sevenPic.vue?vue&type=script&lang=js"
export * from "./sevenPic.vue?vue&type=script&lang=js"
import style0 from "./sevenPic.vue?vue&type=style&index=0&id=35e6ec6f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35e6ec6f",
  null
  
)

export default component.exports